module.exports = __webpack_public_path__ + "img/close_black.f50a5534.svg";